import { ElementType, HTMLAttributes, ReactNode } from "react";
import { useReveal } from "@/hooks/useReveal";
import { cn } from "@/lib/utils";

type Variant = "up" | "fade" | "stagger";

interface RevealProps extends HTMLAttributes<HTMLElement> {
  as?: ElementType;
  variant?: Variant;
  children: ReactNode;
  threshold?: number;
  rootMargin?: string;
}

export default function Reveal({
  as: Tag = "div",
  variant = "up",
  className,
  children,
  threshold,
  rootMargin,
  ...rest
}: RevealProps) {
  const ref = useReveal<HTMLElement>({ threshold, rootMargin });
  const variantClass =
    variant === "fade" ? "reveal-fade" : variant === "stagger" ? "reveal-stagger" : "reveal-up";
  return (
    <Tag ref={ref as never} className={cn(variantClass, className)} {...rest}>
      {children}
    </Tag>
  );
}